<script lang="ts" setup>
import { defineComponent } from 'vue'
import { commonTexts } from './configs/common'
</script>

<script lang="ts">
export default defineComponent({
  name: 'NotFound',
})
</script>

<template>
  <div class="py-20 w-50 mx-a text-center">
    <img class="w-100px inline" src="@/assets/cover-empty.png">
    <p class="mt-14px text-center text-13px text-n-text-2">
      {{ commonTexts.pageNotFound }}
    </p>

    <div class="flex justify-center">
      <router-link :to="{ name: 'home' }" replace>
        <button class="mt-15 px-4 py-2 text-n-primary border-n-primary border-1 border-solid rounded-full">
          {{ commonTexts.goToHomePage }}
        </button>
      </router-link>
    </div>
  </div>
</template>
